import { useState } from "react";
import { Mail, Inbox } from "lucide-react";

// Shadcn Components
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

// Layout
import OrganizationLayout from '../../components/organization/OrganizationLayout';

// Email Templates Tab
import EmailTemplatesTab from './EmailTemplatesTab';

// Email Tracker Tab
import EmailTrackerTab from './EmailTrackerTab';

function EmailDashboard() {
    const [activeTab, setActiveTab] = useState<string>('tracker');

    return (
        <OrganizationLayout>
            <div className="space-y-6">
                <div className="flex items-center justify-between">
                    <h2 className="text-3xl font-bold tracking-tight">Email Dashboard</h2>
                </div>

                <Tabs defaultValue="tracker" className="space-y-4" onValueChange={setActiveTab}>
                    <TabsList className="transition-none">
                        <TabsTrigger value="tracker" className="flex items-center gap-2 transition-none">
                            <Inbox className="h-4 w-4" />
                            Email Tracker
                        </TabsTrigger>
                        <TabsTrigger value="templates" className="flex items-center gap-2 transition-none">
                            <Mail className="h-4 w-4" />
                            Email Templates
                        </TabsTrigger>
                    </TabsList>

                    <TabsContent value="templates" className="space-y-4">
                        <Card>
                            <CardHeader>
                                <CardTitle>Email Templates</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <EmailTemplatesTab />
                            </CardContent>
                        </Card>
                    </TabsContent>

                    <TabsContent value="tracker" className="space-y-4">
                        <Card>
                            <CardHeader>
                                <CardTitle>Email Tracker</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <EmailTrackerTab />
                            </CardContent>
                        </Card>
                    </TabsContent>
                </Tabs>
                <div className="h-8" />
            </div>
        </OrganizationLayout>
    );
}

export default EmailDashboard; 